import React, { useState, useEffect } from "react";
import PropTypes from "prop-types";
import ContainerPop from "../../Pops/ContainerPop";
import { Helper } from "../../../tools/Helper";
import { api_Routes } from "../../../tools/api_Routes";
import {
  successToaster,
  errorToaster,
} from "../../../helper/toasterConfiguration";
import ButtonClose from "../../Pops/ButtonClose";
import { CircularProgress } from "@mui/material";
import { IoMdCloseCircleOutline } from "react-icons/io";

const VerifyModal = ({ show, handleClose, selectedId, triggerRefresh }) => {
  const [isLoading, setIsLoading] = useState(false);

  useEffect(() => {
    const handleKeyDown = (event) => {
      if (event.key === "Escape" && show) {
        handleClose();
      }
    };
    window.addEventListener("keydown", handleKeyDown);
    return () => {
      window.removeEventListener("keydown", handleKeyDown);
    };
  }, [show, handleClose]);

  const handleSubmit = async () => {
    if (!selectedId || isLoading) return;
    setIsLoading(true);
    const formdata = new FormData();
    formdata.append("verified", "1");
    try {
      const { response } = await Helper.Post({
        url: `${api_Routes.Review.Verify}${selectedId}`,
        hasToken: true,
        data: formdata,
      });
      if (response) {
        successToaster("Review successfully verified");
        handleClose();
        triggerRefresh();
      }
    } catch (error) {
      console.error("An error occurred during verification:", error);
      errorToaster("Failed to verify review. Please try again.");
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <div
      role="dialog"
      aria-modal="true"
      className={`fixed inset-0 z-50 ${
        show ? "visible" : "hidden"
      } bg-black bg-opacity-50 flex justify-center items-center`}
      onClick={handleClose}
    >
      <ContainerPop>
        <div
          className="relative z-50 w-[32em] max-w-full p-4 rounded-sm bg-secondary dark:bg-darkPrimary"
          onClick={(e) => e.stopPropagation()}
        >
          <button
            className="absolute top-6 right-4"
            aria-label="Close modal"
            onClick={handleClose}
          >
            <IoMdCloseCircleOutline size={"1.3rem"} />
          </button>
          <div className="text-center">
            <div className="text-[#4caf50] w-[5em] h-[5em] border-[.25em] border-[#4caf50] rounded-full mx-auto mt-5">
              <span className="text-[3.75rem]">✔</span>
            </div>
            <h2 className="font-bold text-3xl mt-4">Verify Review?</h2>
            <p className="mt-2 text-[#6c757d]">
              Are you sure you want to verify this review? This action is
              irreversible.
            </p>
            <div className="mt-4 flex justify-center gap-4">
              <button
                type="button"
                onClick={handleSubmit}
                className="bg-primary text-white font-medium py-2 px-6 rounded"
              >
                {isLoading ? (
                  <CircularProgress size={24} sx={{ color: "white" }} />
                ) : (
                  "Yes, verify it!"
                )}
              </button>
              <ButtonClose onClick={handleClose} />
            </div>
          </div>
        </div>
      </ContainerPop>
    </div>
  );
};

VerifyModal.propTypes = {
  show: PropTypes.bool.isRequired,
  handleClose: PropTypes.func.isRequired,
  selectedId: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  triggerRefresh: PropTypes.func.isRequired,
};

export default VerifyModal;
